import PropTypes from "prop-types";
import React, { useReducer } from "react";

import API from "../../API";
import {
  POPULATE_REGISTER_API_RESPONSE,
  POPULATE_MANIFEST_RESPONSE,
  POPULATE_SHIPPING_RESPONSE,
} from "../types";
import DeploymentContext from "./deploymentContext";
import deploymentReducer from "./deploymentReducer";

const DeploymentState = ({ children }) => {
  const initialState = {
    registerApiResponse: null,
    manifestResponse: null,
  };

  const [state, dispatch] = useReducer(deploymentReducer, initialState);

  const requestShipping = async(emails) => {
    let shippingResponse = null;
    try {
      shippingResponse = await API.registration.shipping(emails);
    } catch (regErr) {
      shippingResponse = regErr;
      console.error("error requesting shipping from registration: %j", regErr);
    }

    dispatch({
      type: POPULATE_SHIPPING_RESPONSE,
      payload: shippingResponse,
    });
  };
  
  const uploadManifest = async (manifestFile, customer, fleetName, emails, cluster) => {
    let manifestResponse = null;
    try {
      manifestResponse = await API.registration.manifest(
        manifestFile,
        customer,
        fleetName,
        emails,
        cluster,
      );
    } catch (regErr) {
      console.error("error sending manifests to registration: %j", regErr);
    }

    dispatch({
      type: POPULATE_MANIFEST_RESPONSE,
      payload: manifestResponse,
    });
  };

  const registerFromCsv = async (vehicleFINs, customer, fleetName, emails, cluster) => {
    let registrationResponses = [];
    try {
      const responseData = await API.registration.register(
        vehicleFINs,
        customer,
        fleetName,
        emails,
        cluster,
      );
      registrationResponses = [...registrationResponses, responseData];
    } catch (regErr) {
      console.error("error sending vehicles to registration: %j", regErr);
    }
    dispatch({
      type: POPULATE_REGISTER_API_RESPONSE,
      payload: registrationResponses,
    });
  };

  return (
    <DeploymentContext.Provider
      value={{
        ...state,
        registerFromCsv,
        uploadManifest,
        requestShipping,
      }}
    >
      {children}
    </DeploymentContext.Provider>
  );
};

DeploymentState.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DeploymentState;
